import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { MessageWrapper } from '../Styles';

export const IPAddress = observer(() => {
  const {
    DebuggerStore: { logCount, logData },
  } = useStores();

  if (logCount === 0) return null;

  return <MessageWrapper>{logData[0]?.ipAddress}</MessageWrapper>;
});

export default IPAddress;
